import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { find, map } from 'lodash';

import { amountToUsd } from '@utils/currency';
import { BenefitGroupTypes, tBenefitGroupType } from '@models/PersonalAccidentPlanBenefitGroup';
import { PersonalAccidentPlanBenefit } from '@models/PersonalAccidentPlanBenefit';

import { selectPersonalAccidentQuoteComparePage } from './selector';
import { TableRowHeader } from './table-row-header';
import { TableRowItem } from './table-row-item';

const TableAnnualLimit = () => {
  const { t } = useTranslation();
  const { personalAccidentQuotes } = useSelector(selectPersonalAccidentQuoteComparePage);

  const findType = (personalAccidentPlanBenefits: PersonalAccidentPlanBenefit[], type: string) => {
    return find(personalAccidentPlanBenefits, ({ benefitType }) => benefitType === type);
  };

  if (!personalAccidentQuotes) return null;

  return (
    <>
      <TableRowHeader header={t('personalAccidentQuote.annualLimit')} />

      <TableRowItem title={tBenefitGroupType(BenefitGroupTypes.DeathAndPermanentDisablement)}>
        {map(personalAccidentQuotes, ({ id, annualLimitAmount }) => (
          <td key={id}>{amountToUsd(annualLimitAmount)}</td>
        ))}
      </TableRowItem>

      <TableRowItem title={tBenefitGroupType(BenefitGroupTypes.MedicalExpense)}>
        {map(personalAccidentQuotes, ({ id, personalAccidentPlanBenefits }) => (
          <td key={id}>
            {findType(personalAccidentPlanBenefits, 'outpatient_annual_maximum_limit_per_insured_person')?.description}
          </td>
        ))}
      </TableRowItem>

      <TableRowItem title={tBenefitGroupType(BenefitGroupTypes.Others)}>
        {map(personalAccidentQuotes, ({ id, personalAccidentPlanBenefits }) => (
          <td key={id}>
            {
              findType(personalAccidentPlanBenefits, 'personalAccident_checkup_maximum_limit_per_policy_period')
                ?.description
            }
          </td>
        ))}
      </TableRowItem>

      <TableRowItem title={tBenefitGroupType(BenefitGroupTypes.Iema)}>
        {map(personalAccidentQuotes, ({ id, personalAccidentPlanBenefits }) => (
          <td key={id}>
            {findType(personalAccidentPlanBenefits, 'maternity_maximum_limit_per_policy_period')?.description}
          </td>
        ))}
      </TableRowItem>
    </>
  );
};

export { TableAnnualLimit };
